/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetCodeTenantData200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PatchCodeTenantDataModel } from '../models';
// @ts-ignore
import type { PostCodeTenantDataModel } from '../models';
/**
 * CodeExplorerTenantDataApi - axios parameter creator
 * @export
 */
export const CodeExplorerTenantDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete code reaction and note
         * @summary Code Explorer Delete Tenant Data
         * @param {string} codeId 
         * @param {Array<string>} [reaction] 
         * @param {Array<string>} [note] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCodeTenantData: async (codeId: string, reaction?: Array<string>, note?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeId' is not null or undefined
            assertParamExists('deleteCodeTenantData', 'codeId', codeId)
            const localVarPath = `/api/v1/ce/tenantData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (codeId !== undefined) {
                localVarQueryParameter['codeId'] = codeId;
            }

            if (reaction) {
                localVarQueryParameter['reaction'] = reaction.join(COLLECTION_FORMATS.csv);
            }

            if (note) {
                localVarQueryParameter['note'] = note.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all codes reaction and notes
         * @summary Code Explorer Get Tenant Data
         * @param {string} [searchparam] 
         * @param {boolean} [reaction] 
         * @param {boolean} [isnote] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodeTenantData: async (searchparam?: string, reaction?: boolean, isnote?: boolean, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ce/tenantData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (searchparam !== undefined) {
                localVarQueryParameter['searchparam'] = searchparam;
            }

            if (reaction !== undefined) {
                localVarQueryParameter['reaction'] = reaction;
            }

            if (isnote !== undefined) {
                localVarQueryParameter['isnote'] = isnote;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update note
         * @summary Code Explorer Patch Note
         * @param {PatchCodeTenantDataModel} patchCodeTenantDataModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCodeTenantData: async (patchCodeTenantDataModel: PatchCodeTenantDataModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patchCodeTenantDataModel' is not null or undefined
            assertParamExists('patchCodeTenantData', 'patchCodeTenantDataModel', patchCodeTenantDataModel)
            const localVarPath = `/api/v1/ce/tenantData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchCodeTenantDataModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add code reaction and note
         * @summary Code Explorer Post Tenant Data
         * @param {PostCodeTenantDataModel} postCodeTenantDataModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCodeTenantData: async (postCodeTenantDataModel: PostCodeTenantDataModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postCodeTenantDataModel' is not null or undefined
            assertParamExists('postCodeTenantData', 'postCodeTenantDataModel', postCodeTenantDataModel)
            const localVarPath = `/api/v1/ce/tenantData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCodeTenantDataModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CodeExplorerTenantDataApi - functional programming interface
 * @export
 */
export const CodeExplorerTenantDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CodeExplorerTenantDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete code reaction and note
         * @summary Code Explorer Delete Tenant Data
         * @param {string} codeId 
         * @param {Array<string>} [reaction] 
         * @param {Array<string>} [note] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCodeTenantData(codeId: string, reaction?: Array<string>, note?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCodeTenantData(codeId, reaction, note, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerTenantDataApi.deleteCodeTenantData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all codes reaction and notes
         * @summary Code Explorer Get Tenant Data
         * @param {string} [searchparam] 
         * @param {boolean} [reaction] 
         * @param {boolean} [isnote] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCodeTenantData(searchparam?: string, reaction?: boolean, isnote?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCodeTenantData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCodeTenantData(searchparam, reaction, isnote, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerTenantDataApi.getCodeTenantData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update note
         * @summary Code Explorer Patch Note
         * @param {PatchCodeTenantDataModel} patchCodeTenantDataModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCodeTenantData(patchCodeTenantDataModel: PatchCodeTenantDataModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCodeTenantData(patchCodeTenantDataModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerTenantDataApi.patchCodeTenantData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add code reaction and note
         * @summary Code Explorer Post Tenant Data
         * @param {PostCodeTenantDataModel} postCodeTenantDataModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCodeTenantData(postCodeTenantDataModel: PostCodeTenantDataModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCodeTenantData(postCodeTenantDataModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerTenantDataApi.postCodeTenantData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CodeExplorerTenantDataApi - factory interface
 * @export
 */
export const CodeExplorerTenantDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CodeExplorerTenantDataApiFp(configuration)
    return {
        /**
         * Delete code reaction and note
         * @summary Code Explorer Delete Tenant Data
         * @param {string} codeId 
         * @param {Array<string>} [reaction] 
         * @param {Array<string>} [note] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCodeTenantData(codeId: string, reaction?: Array<string>, note?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCodeTenantData(codeId, reaction, note, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all codes reaction and notes
         * @summary Code Explorer Get Tenant Data
         * @param {string} [searchparam] 
         * @param {boolean} [reaction] 
         * @param {boolean} [isnote] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodeTenantData(searchparam?: string, reaction?: boolean, isnote?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetCodeTenantData200Response> {
            return localVarFp.getCodeTenantData(searchparam, reaction, isnote, pgNum, pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Update note
         * @summary Code Explorer Patch Note
         * @param {PatchCodeTenantDataModel} patchCodeTenantDataModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCodeTenantData(patchCodeTenantDataModel: PatchCodeTenantDataModel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchCodeTenantData(patchCodeTenantDataModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Add code reaction and note
         * @summary Code Explorer Post Tenant Data
         * @param {PostCodeTenantDataModel} postCodeTenantDataModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCodeTenantData(postCodeTenantDataModel: PostCodeTenantDataModel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postCodeTenantData(postCodeTenantDataModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CodeExplorerTenantDataApi - interface
 * @export
 * @interface CodeExplorerTenantDataApi
 */
export interface CodeExplorerTenantDataApiInterface {
    /**
     * Delete code reaction and note
     * @summary Code Explorer Delete Tenant Data
     * @param {string} codeId 
     * @param {Array<string>} [reaction] 
     * @param {Array<string>} [note] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerTenantDataApiInterface
     */
    deleteCodeTenantData(codeId: string, reaction?: Array<string>, note?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get all codes reaction and notes
     * @summary Code Explorer Get Tenant Data
     * @param {string} [searchparam] 
     * @param {boolean} [reaction] 
     * @param {boolean} [isnote] 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerTenantDataApiInterface
     */
    getCodeTenantData(searchparam?: string, reaction?: boolean, isnote?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetCodeTenantData200Response>;

    /**
     * Update note
     * @summary Code Explorer Patch Note
     * @param {PatchCodeTenantDataModel} patchCodeTenantDataModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerTenantDataApiInterface
     */
    patchCodeTenantData(patchCodeTenantDataModel: PatchCodeTenantDataModel, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Add code reaction and note
     * @summary Code Explorer Post Tenant Data
     * @param {PostCodeTenantDataModel} postCodeTenantDataModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerTenantDataApiInterface
     */
    postCodeTenantData(postCodeTenantDataModel: PostCodeTenantDataModel, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * CodeExplorerTenantDataApi - object-oriented interface
 * @export
 * @class CodeExplorerTenantDataApi
 * @extends {BaseAPI}
 */
export class CodeExplorerTenantDataApi extends BaseAPI implements CodeExplorerTenantDataApiInterface {
    /**
     * Delete code reaction and note
     * @summary Code Explorer Delete Tenant Data
     * @param {string} codeId 
     * @param {Array<string>} [reaction] 
     * @param {Array<string>} [note] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerTenantDataApi
     */
    public deleteCodeTenantData(codeId: string, reaction?: Array<string>, note?: Array<string>, options?: RawAxiosRequestConfig) {
        return CodeExplorerTenantDataApiFp(this.configuration).deleteCodeTenantData(codeId, reaction, note, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all codes reaction and notes
     * @summary Code Explorer Get Tenant Data
     * @param {string} [searchparam] 
     * @param {boolean} [reaction] 
     * @param {boolean} [isnote] 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerTenantDataApi
     */
    public getCodeTenantData(searchparam?: string, reaction?: boolean, isnote?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig) {
        return CodeExplorerTenantDataApiFp(this.configuration).getCodeTenantData(searchparam, reaction, isnote, pgNum, pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update note
     * @summary Code Explorer Patch Note
     * @param {PatchCodeTenantDataModel} patchCodeTenantDataModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerTenantDataApi
     */
    public patchCodeTenantData(patchCodeTenantDataModel: PatchCodeTenantDataModel, options?: RawAxiosRequestConfig) {
        return CodeExplorerTenantDataApiFp(this.configuration).patchCodeTenantData(patchCodeTenantDataModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add code reaction and note
     * @summary Code Explorer Post Tenant Data
     * @param {PostCodeTenantDataModel} postCodeTenantDataModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerTenantDataApi
     */
    public postCodeTenantData(postCodeTenantDataModel: PostCodeTenantDataModel, options?: RawAxiosRequestConfig) {
        return CodeExplorerTenantDataApiFp(this.configuration).postCodeTenantData(postCodeTenantDataModel, options).then((request) => request(this.axios, this.basePath));
    }
}

